import { Button, message, Modal } from "antd";
import { useEffect, useRef, useState } from "react";
import { dispatchAdminNotification } from "../../../utils/adminNotification";
import { api } from "../../../utils/api";

export const ResendDownloadJobEmailButton = ({
  licenseId,
}: {
  licenseId: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleSubmit = () => {
    if (isSubmittingRef.current) return;

    if (typeof navigator !== "undefined" && !navigator.onLine) {
      setIsOpen(false);
      message.error("ネットワーク接続を確認のうえ、再度お試しください。");
      return;
    }

    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setIsOpen(false);
    message.info(
      "メールの再送信処理を開始しました。完了後に結果をお知らせします。",
    );

    api
      .post(
        `api/admin/app-download-jobs/${licenseId}/resend-app-download-email`,
        undefined,
        { skipGlobalLoading: true } as any,
      )
      .then((res) => {
        const email = res?.data?.data?.email;

        dispatchAdminNotification({
          type: "success",
          message: "メールを再送信しました。",
          description: email ? `送信先: ${email}` : undefined,
        });
      })
      .catch((e: any) => {
        console.error("Failed to resend download email", e);
        dispatchAdminNotification({
          type: "error",
          message: "メールの再送信に失敗しました。",
        });
      })
      .finally(() => {
        isSubmittingRef.current = false;
        if (isMountedRef.current) {
          setIsSubmitting(false);
        }
      });
  };

  return (
    <>
      <Button
        className="base-button-outline w-[66px] h-[41px]"
        onClick={() => setIsOpen(true)}
        disabled={isSubmitting}
      >
        再送信
      </Button>
      <Modal
        open={isOpen}
        onOk={handleSubmit}
        onCancel={() => setIsOpen(false)}
        confirmLoading={isSubmitting}
        okText="送信"
        cancelText="キャンセル"
        closeIcon={false}
        width={389}
        className="custom-modal-resend-download-app"
        footer={() => (
          <div className="flex justify-center gap-[10px] mt-4">
            <Button
              onClick={() => setIsOpen(false)}
              className="base-button-outline w-[101px] h-[32px]"
            >
              いいえ
            </Button>
            <Button
              onClick={handleSubmit}
              className="base-button w-[101px] h-[32px]"
              loading={isSubmitting}
            >
              はい
            </Button>
          </div>
        )}
      >
        <p className="mb-0 font-medium text-xl text-center">
          RecOrbのダウンロードリンクを再送信しますか。
        </p>
      </Modal>
    </>
  );
};
